<template>
  <div>
    <template v-if="loading">
      <Loader></Loader>
    </template>
    <template v-else>
      <template v-if="is_counselling_accessible">
        <div class="nav">
          <div @click="setActiveTab(0)">
            <h5
              :class="{active:(active_tab == 0 || completed_tabs.indexOf(0) != -1)}"
            >Background {{completed_tabs.indexOf(0) == -1 ? '' : '✓'}}</h5>
          </div>
          <div @click="setActiveTab(1)">
            <h5
              :class="{active:(active_tab == 1 || completed_tabs.indexOf(1) != -1)}"
            >Academics {{completed_tabs.indexOf(1) == -1 ? '' : '✓'}}</h5>
          </div>
          <div @click="setActiveTab(2)">
            <h5
              :class="{active:(active_tab == 2 || completed_tabs.indexOf(2) != -1)}"
            >Work Experience {{completed_tabs.indexOf(2) == -1 ? '' : '✓'}}</h5>
          </div>
          <div @click="setActiveTab(3)">
            <h5
              :class="{active:(active_tab == 3 || completed_tabs.indexOf(3) != -1)}"
            >Activities/Interests {{completed_tabs.indexOf(3) == -1 ? '' : '✓'}}</h5>
          </div>
          <div @click="setActiveTab(4)">
            <h5
              :class="{active:(active_tab == 4 || completed_tabs.indexOf(4) != -1)}"
            >Guidance {{completed_tabs.indexOf(4) == -1 ? '' : '✓'}}</h5>
          </div>
        </div>

        <div class="content">
          <template v-if="active_tab==0">
            <div>
              <h4 class="content-title">{{tabs[0]}}</h4>
              <div class="info_wrapper">
                <b-container fluid>
                  <b-row>
                    <b-col sm="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Full Name</label>
                        <b-form-input
                          id="exampleInput1"
                          type="text"
                          v-model="user_info.full_name"
                          disabled
                          placeholder="Your Full Name"
                        ></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Gender</label>
                        <b-form-input v-model="user_info.gender" disabled></b-form-input>
                      </div>
                    </b-col>
                    <b-col sm="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Your Birthday</label>
                        <b-form-input type="date" disabled :value="user_birth_date"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="7" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Father's Name</label>
                        <b-form-input type="text" v-model="form.background.fathers_name"></b-form-input>
                      </div>
                    </b-col>
                    <b-col sm="12" lg="5" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Occupation</label>
                        <b-form-input type="text" v-model="form.background.fathers_occupation"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="7" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Mother's Name</label>
                        <b-form-input type="text" v-model="form.background.mothers_name"></b-form-input>
                      </div>
                    </b-col>
                    <b-col sm="12" lg="5" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Occupation</label>
                        <b-form-input type="text" v-model="form.background.mothers_occupation"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="12" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Permanent Address</label>
                        <b-row>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Country" v-model="form.background.permanent_address.country"></b-form-input>
                          </b-col>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="State" v-model="form.background.permanent_address.state"></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="City" v-model="form.background.permanent_address.city"></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="number" placeholder="Postal Code" v-model="form.background.permanent_address.postal_code"></b-form-input>
                          </b-col>

                          <b-col
                            sm="12"
                            md="12"
                            lg="12"
                            class="mobile-no-padding"
                            style="margin-top:10px"
                          >
                            <b-form-textarea rows="5" placeholder="Address Line" v-model="form.background.permanent_address.address_line"></b-form-textarea>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="12" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Mailing Address</label>
                        <b-row>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Country" v-model="form.background.mailing_address.country"></b-form-input>
                          </b-col>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="State" v-model="form.background.mailing_address.state"></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="City" v-model="form.background.mailing_address.city"></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="number" placeholder="Postal Code" v-model="form.background.mailing_address.postal_code"></b-form-input>
                          </b-col>

                          <b-col
                            sm="12"
                            md="12"
                            lg="12"
                            class="mobile-no-padding"
                            style="margin-top:10px"
                          >
                            <b-form-textarea rows="5" placeholder="Address Line" v-model="form.background.mailing_address.address_line"></b-form-textarea>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="12" lg="12" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Primary Phone</label>
                        <b-row>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Phone Type" v-model="form.background.primary_phone.phone_type"></b-form-input>
                          </b-col>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Country Code" v-model="form.background.primary_phone.country_code" ></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Phone No." v-model="form.background.primary_phone.phone_no"></b-form-input>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12" lg="12" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Alternate Phone</label>
                        <b-row>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Phone Type" v-model="form.background.alternate_phone.phone_type"></b-form-input>
                          </b-col>
                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Country Code" v-model="form.background.alternate_phone.country_code"></b-form-input>
                          </b-col>

                          <b-col sm="12" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Phone No." v-model="form.background.alternate_phone.phone_no"></b-form-input>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col sm="12" lg="12" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Languages Known</label>
                        <b-row>
                          <b-col cols="6" sm="4" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Language" v-model="form.background.languages_known[0].language"></b-form-input>
                          </b-col>
                          <b-col cols="6" sm="8" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Proficiency" v-model="form.background.languages_known[0].proficiency"></b-form-input>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Language" v-model="form.background.languages_known[1].language"></b-form-input>
                          </b-col>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Proficiency" v-model="form.background.languages_known[1].proficiency"></b-form-input>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Language" v-model="form.background.languages_known[2].language"></b-form-input>
                          </b-col>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Proficiency" v-model="form.background.languages_known[2].proficiency"></b-form-input>
                          </b-col>
                        </b-row>

                        <b-row>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Language" v-model="form.background.languages_known[3].language"></b-form-input>
                          </b-col>
                          <b-col cols="6" sm="6" md="6" lg="3" class="mobile-no-padding">
                            <b-form-input type="text" placeholder="Proficiency" v-model="form.background.languages_known[3].proficiency"></b-form-input>
                          </b-col>
                        </b-row>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </template>
          <!-- background section completed -->
          
          <template v-if="active_tab==1">
            <div>
              <h4 class="content-title">{{tabs[1]}}</h4>

              <div class="info_wrapper">
                <b-container fluid>
                  <label>Secondary School (High School)</label>
                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        
                        <b-form-input type="text" placeholder="Secondary School Name" v-model="form.academics.high_school.name"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Address" v-model="form.academics.high_school.address"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Start Year" v-model="form.academics.high_school.start_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="End Year" v-model="form.academics.high_school.end_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Max. Marks" v-model="form.academics.high_school.max_marks"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Marks Obtained" v-model="form.academics.high_school.marks_obtained"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Percentage" v-model="form.academics.high_school.percentage"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
                <!-- Secondary School End -->
                <label>University/College Granting First (Bachelor's) Degree</label>
                <b-container fluid>
                  
                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        
                        <b-form-input type="text" placeholder="University/College Name" v-model="form.academics.university.name"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Address" v-model="form.academics.university.address"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Start Year" v-model="form.academics.university.start_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="End Year" v-model="form.academics.university.end_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Stream" v-model="form.academics.university.stream"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Degree" v-model="form.academics.university.degree"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Max. Marks"  v-model="form.academics.university.max_marks"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Marks Obtained" v-model="form.academics.university.marks_obtained"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Percentage" v-model="form.academics.university.percentage"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <label>GPA</label>
                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Scale" v-model="form.academics.university.gpa.scale"></b-form-input>
                      </div>
                    </b-col>

                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Cumulative" v-model="form.academics.university.gpa.cumulative"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="First Year" v-model="form.academics.university.gpa.first_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Second Year" v-model="form.academics.university.gpa.second_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Third Year" v-model="form.academics.university.gpa.third_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Fourth Year" v-model="form.academics.university.gpa.fourth_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <label>Professional Certification/Course</label>
                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Institute Name" v-model="form.academics.professional_certification.institute_name"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Institute Address" v-model="form.academics.professional_certification.institute_address"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Start Year" v-model="form.academics.professional_certification.start_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="End Year" v-model="form.academics.professional_certification.end_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Stream" v-model="form.academics.professional_certification.stream"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Degree" v-model="form.academics.professional_certification.degree"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Level/Paper (Last Pass)" v-model="form.academics.professional_certification.level"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Max. Marks" v-model="form.academics.professional_certification.max_marks"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Marks Obtained" v-model="form.academics.professional_certification.marks_obtained"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Percentage" v-model="form.academics.professional_certification.percentage"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <label>Test Scores</label>
                  <b-row>
                    <b-col cols="12" lg="8" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Name of Entrance Exam" v-model="form.academics.test_scores.name"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Quant" v-model="form.academics.test_scores.quant"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Verbal" v-model="form.academics.test_scores.verbal"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Logic" v-model="form.academics.test_scores.logic"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="DI" v-model="form.academics.test_scores.di"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Other" v-model="form.academics.test_scores.other"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Total" v-model="form.academics.test_scores.total"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </template>
          <!-- academics section completed -->

          <template v-if="active_tab==2">
            <div>
              <h4 class="content-title">{{tabs[2]}}</h4>
              
              <div class="info_wrapper">
                <label>Current Work Experience</label>
                <b-container fluid>
                  <b-row>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Name of the Organization/Employer" v-model="form.work_experience.current.name_of_organization">
                      </b-form-input>
                    </b-col>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Industry" v-model="form.work_experience.current.industry">
                      </b-form-input>
                    </b-col>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Address" v-model="form.work_experience.current.address">
                      </b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Start Year" v-model="form.work_experience.current.start_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="End Year" v-model="form.work_experience.current.end_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Designation" v-model="form.work_experience.current.designation"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="6" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Function" v-model="form.work_experience.current.function"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Full time/ Part time</label>
                        <b-form-select placeholder="Full time/ Part time" v-model="form.work_experience.current.full_time">
                          <option value="full_time" selected>Full Time</option>
                          <option value="part_time">Part Time</option>
                        </b-form-select>
                      </div>
                    </b-col>

                  </b-row>

                </b-container>

                <label>Past Work Experience</label>
                <b-container fluid>
                  <b-row>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Name of the Organization/Employer" v-model="form.work_experience.past.name_of_organization">
                      </b-form-input>
                    </b-col>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Industry" v-model="form.work_experience.past.industry">
                      </b-form-input>
                    </b-col>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input 
                        type="text" 
                        placeholder="Address" v-model="form.work_experience.past.address">
                      </b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="Start Year" v-model="form.work_experience.past.start_year"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="number" placeholder="End Year" v-model="form.work_experience.past.end_year"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Designation" v-model="form.work_experience.past.designation"></b-form-input>
                      </div>
                    </b-col>
                    <b-col cols="12" lg="6" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <b-form-input type="text" placeholder="Function" v-model="form.work_experience.past.function"></b-form-input>
                      </div>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12" lg="3" class="mobile-no-padding">
                      <div class="input-wrapper">
                        <label>Full time/ Part time</label>
                        <b-form-select placeholder="Full time/ Part time" v-model="form.work_experience.past.full_time">
                          <option value="full_time" selected>Full Time</option>
                          <option value="part_time">Part Time</option>
                        </b-form-select>
                      </div>
                    </b-col>

                  </b-row>

                </b-container>
              </div>

            </div>
          </template>
          <!-- work experience completed -->


          <template v-if="active_tab==3">
            <div>
              <h4 class="content-title">{{tabs[3]}}</h4>
              <div class="info_wrapper">
                <label>Activities/Interests</label>
                <b-container fluid>
                  <b-row>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="Name" v-model="form.activities_interests.activities.name"></b-form-input>
                    </b-col>
                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="When did you pursue this Activity/Interest" v-model="form.activities_interests.activities.when_pursue"></b-form-input>
                    </b-col>

                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="number" placeholder="Number of members" v-model="form.activities_interests.activities.number_of_members"></b-form-input>
                    </b-col>

                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="How much time did you spend?" v-model="form.activities_interests.activities.time_spent"></b-form-input>
                    </b-col>

                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="What role(s) did you play?" v-model="form.activities_interests.activities.role"></b-form-input>
                    </b-col>

                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-textarea rows=4 placeholder="Description of activity/interest and your role, impact, or contribution" v-model="form.activities_interests.activities.description"></b-form-textarea>
                    </b-col>

                  </b-row>
                </b-container>
                <label>Awards/Honors</label>
                <b-container fluid>
                  <b-row>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="Name" v-model="form.activities_interests.awards.name"></b-form-input>
                    </b-col>
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="When did you get this award/honor?" v-model="form.activities_interests.awards.when_awarded"></b-form-input>
                    </b-col>
                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-input type="text" placeholder="Basis of selection" v-model="form.activities_interests.awards.basis_of_selection"></b-form-input>
                    </b-col>

                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <b-form-textarea placeholder="Description" rows=4 v-model="form.activities_interests.awards.description"></b-form-textarea>
                    </b-col>
                  </b-row>
                </b-container>
              </div>
            </div>
          </template>

          <template v-if="active_tab==4">
            <div>
              <h4 class="content-title">{{tabs[4]}}</h4>
              <div class="info_wrapper">
                
                <b-container fluid>
                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>Name of the exam that you wish to appear for</label>
                      <b-form-input type="text" v-model="form.guidance.name_of_the_exam_wish_to_appear"></b-form-input>
                    </b-col>
                    <b-col cols=12 lg=4 class="mobile-no-padding">
                      <label>Date</label>
                      <b-form-input type="date" v-model="form.guidance.name_of_the_exam_wish_to_appear_date"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>Name of the institute that you are targeting</label>
                      <b-form-input type="text" v-model="form.guidance.name_of_the_institute_targeting"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>Other entrance exam in mind</label>
                      <b-form-input type="text" v-model="form.guidance.other_entrance_in_mind"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>When would you like to be contacted</label>
                      <b-form-input type="text" v-model="form.guidance.when_would_you_like_to_be_contacted"></b-form-input>
                    </b-col>
                    <b-col cols=12 lg=4 class="mobile-no-padding">
                      <label>Time</label>
                      <b-form-input type="time" v-model="form.guidance.when_would_you_like_to_be_contacted_time"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>Would you like to receive email/notifications from the admin?</label>
                      <b-form-input type="text" v-model="form.guidance.email_notifications"></b-form-input>
                    </b-col>
                  </b-row>

                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>Do you want the admin to formulate an appropriate study plan for you?</label>
                      <b-form-radio-group v-model="form.guidance.formulate_study_plan">
                        <b-form-radio value="Yes">Yes</b-form-radio>
                        <b-form-radio value="No">No</b-form-radio>
                      </b-form-radio-group>
                    </b-col>
                  </b-row>

                  <b-row>                    
                    <b-col cols=12 lg=8 class="mobile-no-padding">
                      <label>What are your expectations?</label>
                      <b-form-input type="text" v-model="form.guidance.expectations"></b-form-input>
                    </b-col>
                  </b-row>

                </b-container>
              </div>
            </div>
          </template>

          <b-button
            class="btn query-btn button-touchy"
            variant="primary"
            style="margin-top: 20px; margin-left:0; "
            @click="next()"
          >{{cta_text}}</b-button>
        </div>
      </template>
      <template v-else>
        <h5>You need to Purchase a package to access Career Counselling:</h5>
        <b-link class="btn btn-primary" to="/dashboard/packages" style="margin-top:20px">Upgrade</b-link>
      </template>
    </template>
    <b-modal ref="myModalRef" hide-footer title="Counselling Form" v-model="show_modal">
      <div class="d-block text-center">
        <p>Thank you, we have received your form, our team will reach out to you shortly.</p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Loader from "../Loader";
import moment from "moment";

export default {
  name: "CareerCounselling",
  components: {
    Loader
  },
  data: function() {
    return {
      show_modal: false,
      loading: true,
      tabs: [
        "Background",
        "Academics",
        "Work Experience",
        "Activities/Interests",
        "Guidance"
      ],
      completed_tabs: [],
      active_tab: 0,
      form: {
        background: {
          fathers_name:'',
          fathers_occupation:'',
          mothers_name:'',
          mothers_occupation: '',
          permanent_address: {
            country:'',
            state:'',
            city:'',
            postal_code:'',
            address_line:''
          },
          mailing_address: {
            country:'',
            state:'',
            city:'',
            postal_code:'',
            address_line:''
          },
          primary_phone: {
            phone_type:'',
            country_code:'',
            phone_no:''
          },
          alternate_phone: {
            phone_type:'',
            country_code:'',
            phone_no:''
          },
          languages_known: [
            {
              language:'',
              proficiency:''
            },
            {
              language:'',
              proficiency:'',
            },
            {
              language:'',
              proficiency:''
            }, 
            {
              language:'',
              proficiency:''
            }
          ]
        },
        academics: {
          high_school: {
            name:'',
            address:'',
            start_year:'',
            end_year:'',
            max_marks:'',
            marks_obtained:'',
            percentage:''
          },
          university: {
            name:'',
            address:'',
            start_year:'',
            end_year:'',
            stream:'',
            degree:'',
            max_marks:'',
            marks_obtained:'',
            percentage:'',
            gpa:{
              scale:'',
              cumulative:'',
              first_year:'',
              second_year:'',
              third_year:'',
              fourth_year:''
            }
          },
          professional_certification: {
            institute_name:'',
            institute_address:'',
            start_year:'',
            end_year:'',
            stream:'',
            degree:'',
            level:'',
            max_marks:'',
            marks_obtained:'',
            percentage:''
          },
          test_scores: {
            name:'',
            quant:'',
            verbal:'',
            logic:'',
            di:'',
            other:'',
            total:''
          }

        },
        work_experience: {
          current: {
            name_of_organization:'',
            industry:'',
            address:'',
            start_year:'',
            end_year:'',
            designation:'',
            function:'',
            full_time:''
          },
          past: {
            name_of_organization:'',
            industry:'',
            address:'',
            start_year:'',
            end_year:'',
            designation:'',
            function:'',
            full_time:''
          }
        },
        activities_interests: {
          activities: {
            name:'',
            when_pursue:'',
            number_of_members:'',
            time_spent:'',
            role:'',
            description:''
          },
          awards: {
            name:'',
            when_awarded:'',
            basis_of_selection: '',
            description:''
          }
        },
        guidance: {
          name_of_the_exam_wish_to_appear:'',
          name_of_the_exam_wish_to_appear_date:'',
          name_of_the_institute_targeting:'',
          other_entrance_in_mind:'',
          when_would_you_like_to_be_contacted:'',
          when_would_you_like_to_be_contacted_time:'',
          email_notifications:'',
          formulate_study_plan:'',
          expectations:''
        }
      }
    };
  },
  computed: {
    cta_text: function() {
      if (this.active_tab == this.tabs.length - 1) {
        return "Finish";
      } else {
        return "Save and Continue";
      }
    },
    is_counselling_accessible: function() {
      if (this.packages.length > 0) {
        return true;
      } else return false;
    },
    packages: function() {
      return this.$store.getters.user.packages;
    },
    user_info: function() {
      return this.$store.getters.user;
    },
    user_birth_date: function() {
      if (
        this.user_info.date_of_birth != null &&
        this.user_info.date_of_birth != ""
      ) {
        return moment(this.user_info.date_of_birth).format("YYYY-MM-DD");
      } else {
        return "";
      }
    }
  },
  async mounted() {
    var action = await this.$store.dispatch("fetch_user_packages");
    console.log('getting counselling');
    
    if(this.is_counselling_accessible) {
      var action2 = await this.$store.dispatch("get_counselling_form");
      this.form = action2.data;
    }
  
    this.loading = false;
  },
  methods: {
    setActiveTab(index) {
      this.active_tab = index;
    },
    next() {
      // save the state of the form

      var action = this.$store.dispatch("save_counselling_form", this.form);

      if (this.active_tab < 4) {
        this.completed_tabs.push(this.active_tab);
        this.active_tab = this.active_tab + 1;
      } else {
        this.show_modal=true;
      }
    }
  }
};
</script>

<style>
.content-title {
  user-select: none;
}
.input-wrapper {
  margin: 10px 0;
}
.input-wrapper label {
  margin-bottom: 0.4rem;
  font-weight: bold;
  font-size: 0.9rem;
}

label {
  margin-bottom: 0.4rem;
  font-weight: bold;
  font-size: 0.9rem;
}
.nav {
  width: 100%;
  max-width: 100%;
  display: flex;
  align-items: center;
}
.nav div {
  /* flex-basis:0;
    flex-grow:1; */
  cursor: pointer;
}

.nav div h5 {
  font-size: 0.5rem;
  padding: 10px 10px;
  color: white;
  border: 1px solid #bababa;
  text-align: center;
  border-right: none;
  background-color: #949494;
  user-select: none;
}

.nav div:last-of-type h5 {
  border-right: 1px solid #bababa;
}

.nav div h5.active {
  background-color:#77bf43 !important;
}

@media screen and (max-width: 768px) {
  .nav div h5 {
    font-size: 0.4rem;
    padding: 15px 7px !important;
  }

  .nav div {
    flex-basis: 0;
    flex-grow: 1;
  }
}

@media screen and (max-width: 380px) {
  .nav div h5 {
    font-size: 0.4rem;
    padding: 15px 7px !important;
  }

  .nav div {
    flex-basis: auto;
    flex-grow: auto;
  }
}

@media screen and (min-width: 480px) {
  .nav div h5 {
    font-size: 0.5rem;
  }
}

@media screen and (min-width: 1024px) {
  .nav div {
    flex-basis: 0;
    flex-grow: 1;
  }
  .nav div h5 {
    padding: 15px 7px !important;
    font-size: 1rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/CareerCounselling.vue